<template lang="pug">
table-base.student-select-list-table
  //- ヘッダー部
  table-row-base.student-select-list-table__row-header.text-medium
    table-header-base.student-select-list-table__row-header__cell.align-left
    table-header-base.student-select-list-table__row-header__cell.align-left
      toggle-sort.student-select-list-table__row-header__cell__toggle(
        :sortSetting='sort.nickName',
        @change-sort='sortChangeEvent($event, "nickName")'
      )
        slot(name='nickNameHeader')
    table-header-base.student-select-list-table__row-header__cell.align-left
      toggle-sort.student-select-list-table__row-header__cell__toggle(
        :sortSetting='sort.gradeName',
        @change-sort='sortChangeEvent($event, "gradeName")'
      )
        slot(name='gradeNameHeader')
    table-header-base.student-select-list-table__row-header__cell.align-left
      toggle-sort.student-select-list-table__row-header__cell__toggle(
        :sortSetting='sort.statusName',
        @change-sort='sortChangeEvent($event, "statusName")'
      )
        slot(name='statusNameHeader')
    table-header-base.student-select-list-table__row-header__cell.align-left
      slot(name='lastMinuteCheckStatusHeader')
    table-header-base.student-select-list-table__row-header__cell.align-left
      slot(name='resolveStatusHeader')
  template(v-for='student in studentDatas')
    //- 一覧表示部
    table-row-base.student-select-list-table__row.text-small.font-medium
      table-data-base.student-select-list-table__row__cell
        button-primary.student-select-list-table__row__cell__button(
          @click='resultButtonEvent(student.id)'
        )
          slot(name='resultButtonLabel')
      table-data-base.student-select-list-table__row__cell
        .student-select-list-table__row__cell__text {{ student.nickName }}
      table-data-base.student-select-list-table__row__cell
        .student-select-list-table__row__cell__text {{ student.gradeName }}
      table-data-base.student-select-list-table__row__cell
        .student-select-list-table__row__cell__text {{ student.statusName }}
      table-data-base.student-select-list-table__row__cell
        .student-select-list-table__row__cell__text {{ student.lastMinuteCheckStatus }}
      table-data-base.student-select-list-table__row__cell
        .student-select-list-table__row__cell__text {{ student.resolveStatus }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ToggleSort from '@/components/molecules/manager/ToggleSort.vue'
import ButtonPrimary from '@/components/molecules/manager/ButtonPrimary.vue'
import { StudentSelectListType, StudentSelectListSortType } from '@/models/studentListModel'

/**
 * 生徒選択一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ToggleSort,
    ButtonPrimary,
  },
})
export default class StudentSelectListTable extends Vue {
  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: StudentSelectListSortType

  // ソート値変更時イベント
  @Prop()
  sortChangeEvent!: Function

  // 生徒選択一覧表示情報
  @Prop()
  studentDatas!: StudentSelectListType[]

  // 成績表ボタン押下時イベント
  @Prop()
  resultButtonEvent!: Function
}
</script>

<style lang="stylus" scoped>
.student-select-list-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-child(1)
        width 120px
      &:nth-child(2)
        width 200px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__button
        padding 10px 0

    &:hover
      background var(--color-manager-list__hover)
</style>
